export default __webpack_public_path__ + "static/ensino-fundamental-1-16b0c9f81664c6bb2bf7d762ea1a2493.png";